<template>
	<div class="view-index-h" @click="closeCapsuleDialog">
		<div class="svg-box"></div>
		<div class="inf-wrapper">
			<div class="auto-height">
				<div class="inline-start title-line calc-line">
					<div class="line"></div>
					<div class="caption">公司简介</div>
				</div>
			</div>
			<div class="auto-height">
				<div class="content calc-line" v-html="companyProfile"></div>
			</div>
		</div>
		<div class="inf-wrapper">
			<div class="auto-height">
				<div class="inline-start title-line calc-line">
					<div class="line"></div>
					<div class="caption">企业文化</div>
				</div>
			</div>
			<div class="auto-height">
				<div class="content calc-line" v-html="corporateCulture"></div>
			</div>
		</div>
		<!-- <copy-right /> -->
		<div class="inline-start-b capsule-dialog" :style="capsuleDialogStyle" 
			@mousemove="onHoldCapsuleDialog" @mouseleave="onMouseoutArea" @click.stop="onClickCapsule">
			<img class="park-area-point" src="~@/assets/png/park-area-point.png" />
			<div class="capsule" v-show="!curCapsuleDialogStatus.showDialog" 
				:style="{cursor: capsuleArrowRight ? 'pointer' : 'default'}">
				<span>{{curArea.promptText}}</span>
				<i class="el-icon-arrow-right" v-if="capsuleArrowRight"></i>
			</div>
		</div>
		<div class="pop-dialog" :style="popDialogStyle"
			@mousemove="onHoldCapsuleDialog" @mouseleave="onMouseoutArea">
			<img class="bg" :style="popDialogBgStyle" src="~@/assets/png/pop-bg.png" />
			<div class="content-wrapper" :style="{cursor: areaCanJump ? 'pointer' : 'default'}"
				@click.stop="onClickPopDialog">
				<div class="auto-height">
					<div class="content calc-line" v-html="curArea.popContent"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapGetters
	} from 'vuex'
	import IndexMixin from './mixins/index.js';
	import CopyRight from '@/components/copyRight';
	export default {
		name: 'IndexH',
		mixins: [IndexMixin],
		components: {
			CopyRight
		},
		data() {
			return {
				
			}
		},
		computed: {
			capsuleDialogStyle() {
				if(this.curCapsuleDialogStatus.show) {
					return {
						left: (this.curCapsuleDialogStatus.x + 75 * this.scaleRate) + 'px',
						top: this.curCapsuleDialogStatus.y + 'px'
					}
				}else {
					return {
						display: 'none'
					}
				}
			},
			popDialogStyle() {
				if(this.curCapsuleDialogStatus.showDialog) {
					let offsetX = this.isVerticalScreen ? 52 : 75;
					let offsetY = this.isVerticalScreen ? 50 : 0;
					let left = 0;
					if(this.curCapsuleDialogStatus.rootDomW / 2 < this.curCapsuleDialogStatus.x) {
						left = this.curCapsuleDialogStatus.x + this.scaleRate * (offsetX - 189 + 35);
					}else {
						left = this.scaleRate * (offsetX - 35 + 20) + this.curCapsuleDialogStatus.x;
					}
					return {
						left: left + 'px',
						top: (this.curCapsuleDialogStatus.y + (offsetY + 20) * this.scaleRate) + 'px',
						display: 'block'
					}
				}else {
					return {
						display: 'none'
					}
				}
			}
		},
		methods: {
			
		}
	}
</script>
<style scoped lang="less">
	.view-index-h {
		width: 100%;
		padding-left: calc(75px * var(--scale-rate));
		position: relative;
		.svg-box {
			//border: 1px solid #000000;
			width: 100%;
			height: calc(450px * var(--scale-rate));
			overflow: hidden;
		}
		.inf-wrapper {
			width: 100%;
			padding-left: calc(150px * var(--scale-rate));
			padding-bottom: calc(75px * var(--scale-rate));
			.title-line {
				width: calc(100% / var(--scale-rate));
				transform: scale(var(--scale-rate));
				transform-origin: left top;
				.line {
					background-color: rgb(17, 74, 117);
					width: 4px;
					height: 34px;
				}
				.caption {
					margin-left: 15px;
					font-size: 36px;
					color: rgb(29, 41, 116);
				}
			}
			.content {
				width: calc(100% / var(--scale-rate));
				font-size: 24px;
				color: rgb(35, 35, 35); 
				transform: scale(var(--scale-rate));
				transform-origin: left top; 
				padding-top: 25px;
				padding-left: 18px;
			}
		}
	}
</style>